import { ArtistPageController } from './artist/controller';
import { APIController } from '../api/controller';
import { CheckoutPageController } from './checkout/controller';
import { HomePageController } from './home/controller';
import { AuthController } from '../auth/controller';
import { PricingPageController } from './pricing/controller';
import { ClientModel } from '../client/model';
import { BasketController } from '../basket/controller';
import { AccountLicencesPageController } from './account-licences/controller';
import { AccountOrdersPageController } from './account-orders/controller';
import { AccountOrderPageController } from './account-order/controller';
import { UIController } from '../ui/controller';
import { MasterPageController } from './master/controller';
import { AccountChannelsPageController } from './account-channels/controller';
import { AccountChannelPageController } from './account-channel/controller';
import { CheckoutController } from '../checkout/controller';
import { PrismicController } from '../prismic/controller';
import { PrivacyPolicyPageController } from './privacy-policy/controller';
import { BugsnagController } from '../bugsnag/controller';
import { AccountCommunicationPageController } from './account-communication/controller';
import { ImageController } from '../image/controller';
import { AccountInvitesPageController } from './account-invites/controller';
import { AnalyticsController } from '../analytics/controller';
import { FavouritesPageController } from './favourites/controller';
import { TrackPageController } from './track/controller';
import { AccountProfilePageController } from './account-profile/controller';
import { BrowsePageController } from './browse/controller';
import { SigninPageController } from './signin/controller';
import { ChannelReferralPageController } from './channel-referral/controller';
import { AccountCouponsPageController } from './account-coupons/controller';
import { PlaylistController } from '../playlist/controller';
import { MCNPageController } from './mcn/controller';
import { PartnerPageController } from './partner/controller';
import { AffiliatePageController } from './affiliate/controller';
import { ContentController } from '../content/controller';
import { LanderController } from '../../components/landers/controller';
import { CreatorDashboardPageController } from './creator-dashboard/controller';
import { RegistrationPageController } from './registration/controller';
import { UserController } from '../user/controller';
import { AccountVideosPageController } from './account-videos/controller';
import { AccountHubPageController } from './account-hub/controller';
import { AccountPlaylistsPageController } from './account-playlists/controller';
import { SearchMvpPageController } from './search-mvp/controller';
import { UserPlaylistsPageController } from './user-playlists/controller';
import { ReleasePageController } from './release/controller';

export class PageController {
  master: MasterPageController;
  signin: SigninPageController;
  registration: RegistrationPageController;
  home: HomePageController;
  creatorDashboard: CreatorDashboardPageController;
  artist: ArtistPageController;
  checkout: CheckoutPageController;
  browse: BrowsePageController;
  pricing: PricingPageController;
  accountHub: AccountHubPageController;
  accountCoupons: AccountCouponsPageController;
  accountInvites: AccountInvitesPageController;
  accountLicences: AccountLicencesPageController;
  accountOrders: AccountOrdersPageController;
  accountOrder: AccountOrderPageController;
  accountChannels: AccountChannelsPageController;
  accountChannel: AccountChannelPageController;
  accountCommunication: AccountCommunicationPageController;
  accountProfile: AccountProfilePageController;
  accountVideos: AccountVideosPageController;
  accountPlaylists: AccountPlaylistsPageController;
  searchMvp: SearchMvpPageController;
  privacyPolicy: PrivacyPolicyPageController;
  lander: LanderController;
  favourites: FavouritesPageController;
  track: TrackPageController;
  channelReferral: ChannelReferralPageController;
  mcn: MCNPageController;
  partner: PartnerPageController;
  affiliate: AffiliatePageController;
  userPlaylists: UserPlaylistsPageController;
  release: ReleasePageController;

  constructor(
    model: ClientModel,
    api: APIController,
    auth: AuthController,
    user: UserController,
    basket: BasketController,
    ui: UIController,
    content: ContentController,
    checkout: CheckoutController,
    prismic: PrismicController,
    bugsnag: BugsnagController,
    image: ImageController,
    analytics: AnalyticsController,
    playlist: PlaylistController
  ) {
    this.master = new MasterPageController(ui, model.env, model.router);
    this.signin = new SigninPageController(model.router, model.auth, model.page.registration);
    this.registration = new RegistrationPageController(
      model.page.registration,
      model.onboarding,
      api,
      analytics,
      model.user,
      user,
      model.router
    );
    this.home = new HomePageController(
      model.page,
      model.page.home,
      model.env,
      prismic,
      api,
      analytics,
      ui,
      model.user,
      model.auth
    );
    this.creatorDashboard = new CreatorDashboardPageController(
      model.page,
      model.page.creatorDashboard,
      model.env,
      prismic,
      api,
      analytics,
      ui,
      model.user,
      model.auth,
      bugsnag
    );
    this.artist = new ArtistPageController(
      model.page.artist,
      model.env,
      ui,
      api.artist,
      api.release,
      image,
      model.router,
      bugsnag,
      model.content,
      model.auth
    );
    this.checkout = new CheckoutPageController(
      model.page.checkout,
      checkout,
      model.checkout,
      ui,
      model.env,
      model.auth,
      user,
      analytics,
      content,
      api
    );
    this.browse = new BrowsePageController(
      model.page.browse,
      api,
      ui,
      bugsnag,
      model.content,
      model.env,
      prismic,
      image,
      model.router,
      model.auth
    );
    this.pricing = new PricingPageController(model.page.pricing, prismic, bugsnag, model.env, api, ui, model.content);
    this.accountHub = new AccountHubPageController(
      model.page,
      model.page.accountHub,
      model.env,
      prismic,
      api,
      analytics,
      ui,
      model.auth
    );
    this.accountCoupons = new AccountCouponsPageController(
      model.page.accountCoupons,
      model.user,
      api,
      bugsnag,
      ui,
      model.env,
      model.storage
    );
    this.accountInvites = new AccountInvitesPageController(
      model.page.accountInvites,
      model.user,
      api,
      prismic,
      bugsnag,
      ui,
      model.env,
      model.content
    );
    this.accountLicences = new AccountLicencesPageController(
      model.user,
      model.page.accountLicences,
      api,
      model.env,
      ui,
      bugsnag
    );
    this.accountVideos = new AccountVideosPageController(
      model.user,
      model.page.accountVideos,
      api,
      model.env,
      ui,
      bugsnag
    );
    this.accountPlaylists = new AccountPlaylistsPageController(user, ui, bugsnag);
    this.userPlaylists = new UserPlaylistsPageController(
      model.page.userPlaylists,
      api,
      model.env,
      ui,
      bugsnag,
      model.auth
    );
    this.accountOrders = new AccountOrdersPageController(
      model.user,
      model.page.accountOrders,
      api,
      model.env,
      ui,
      bugsnag
    );
    this.accountOrder = new AccountOrderPageController(model.user, model.page.accountOrder, api, model.env, ui);
    this.accountChannels = new AccountChannelsPageController(
      model.user,
      model.page.accountChannels,
      api,
      model.env,
      ui
    );
    this.accountChannel = new AccountChannelPageController(model.user, model.page.accountChannel, api, model.env, ui);
    this.accountCommunication = new AccountCommunicationPageController(
      model.page.accountCommunication,
      model.auth,
      api,
      model.env,
      prismic,
      ui,
      auth
    );
    this.accountProfile = new AccountProfilePageController(
      model.user,
      model.page.accountProfile,
      api,
      ui,
      model.content,
      model.env,
      auth
    );
    this.searchMvp = new SearchMvpPageController(
      model.page.searchMvp,
      ui,
      model.env,
      model.router,
      analytics,
      api,
      model.user,
      model.content,
      model.graphql
    );
    this.privacyPolicy = new PrivacyPolicyPageController(model.page.privacyPolicy, prismic, bugsnag, model.env, ui);
    this.lander = new LanderController(model.page.lander, prismic, model.env, ui, api, bugsnag);
    this.favourites = new FavouritesPageController(
      model.page.favourites,
      prismic,
      bugsnag,
      model.env,
      api,
      model.user,
      model.playlist,
      model.artistlist,
      ui,
      model.cache
    );
    this.track = new TrackPageController(
      model.page.track,
      bugsnag,
      model.env,
      api,
      ui,
      model.content,
      image,
      model.router,
      analytics,
      model.auth
    );
    this.channelReferral = new ChannelReferralPageController(
      model.page.channelReferral,
      model.env,
      ui,
      model.auth,
      api,
      prismic,
      model.graphql
    );
    this.mcn = new MCNPageController(model.page.mcn, prismic, model.env, ui, model.router, model.content, image);
    this.partner = new PartnerPageController(
      model.page.partner,
      prismic,
      model.env,
      ui,
      model.router,
      model.content,
      image
    );
    this.affiliate = new AffiliatePageController(
      model.page.affiliate,
      prismic,
      model.env,
      ui,
      model.router,
      model.content,
      image
    );
    this.release = new ReleasePageController(
      model.page.release,
      model.env,
      ui,
      api.artist,
      api.release,
      model.router,
      model.auth
    );
  }
}
